import {get, update, getStats, invite} from '../models/User';

const getUserAction = (caller, payload) => {
    return {
        type: "GET_USER_DATA",
        payload: get(caller, payload)
    }
};

const updateUserAction = (caller, payload) => {
    return {
        type: "UPDATE_USER",
        payload: update(caller, payload)
    }
};

const getUserStatsAction = (caller, payload) => {
    return {
        type: "GET_USER_STATS",
        payload: getStats(caller, payload)
    }
};

const sendInvitation = (caller, payload) => {
    return {
        type: "SEND_INVITATION",
        payload: invite(caller, payload.email)
    }
};

export {getUserAction, updateUserAction, getUserStatsAction, sendInvitation};


// WEBPACK FOOTER //
// ./src/actions/User.js